// import { Modal } from '@affine/component';
// import { SignInPanel, type SignInStep } from '@affine/core/components/sign-in';
import { LoginConfig } from '@affine/core/config/login';
import { AuthService } from '@affine/core/modules/cloud';
import { GlobalDialogService } from '@affine/core/modules/dialogs';
import { useI18n } from '@affine/i18n';
import { useService } from '@toeverything/infra';
// import type { AuthSessionStatus } from '@affine/core/modules/cloud/entities/session';
// import type {
//   DialogComponentProps,
//   GLOBAL_DIALOG_SCHEMA,
// } from '@affine/core/modules/dialogs';
import { LoginWrapper } from '@ys/repo-ui/biz/login';
import { useEffect, useState } from 'react';
export const SignInDialog = () => {
  const [isShowLogin, setIsShowLogin] = useState(true);

  const authService = useService(AuthService);
  const globalDialogService = useService(GlobalDialogService);
  const t = useI18n();
  // const onAuthenticated = useCallback(
  //   (status: AuthSessionStatus) => {
  //     if (status === 'authenticated') {
  //       close();
  //     }
  //   },
  //   [close]
  // );
  const getGoogleConfig = () => {
    return {
      clientId: LoginConfig.google.clientId,
      redirectUri: LoginConfig.google.redirectUri,
      loginUri: LoginConfig.google.loginUri,
      scope: LoginConfig.google.scope,
      state: LoginConfig.google.getState(),
    };
  };
  const getAppleConfig = () => {
    return {
      clientId: LoginConfig.apple.clientId,
      redirectUri: LoginConfig.apple.redirectUri,
      loginUri: LoginConfig.apple.loginUri,
      scope: LoginConfig.apple.scope,
      state: LoginConfig.apple.getState(),
      response_type: LoginConfig.apple.response_type,
      response_mode: LoginConfig.apple.response_mode,
    };
  };
  const getLoginCode = async (email: string) => {
    const res = await authService.getLoginCode(email);
    return res;
  };
  const handleReport = async ({
    email,
    code,
  }: {
    email: string;
    code: string;
  }) => {
    const res = await authService.signInEmail({ email, code });
    if (res?.checkStatus) {
      await authService.session.account$.waitFor(account => !!account);
      setTimeout(() => {
        window.location.href = '/';
      }, 50);
    } else if (res.checkStatus !== undefined && !res.checkStatus) {
      globalDialogService.open('invitation-code', {
        onSuccess: () => {
          window.location.href = '/';
        },
        onFailed: () => {},
        localStorageKey: 'email_login_user',
      });
    }
    return res;
  };

  useEffect(() => {
    const preloadImage = new Image();
    preloadImage.src =
      'https://wy-static.wenxiaobai.com/wenxiaobai-web/web-image/muset/newloginImage.jpg';
  }, []);
  return (
    <LoginWrapper
      leftImage="https://wy-static.wenxiaobai.com/wenxiaobai-web/web-image/muset/newloginImage.jpg"
      loginTitle="join muset"
      googleLoginConfig={getGoogleConfig()}
      appleLoginConfig={getAppleConfig()}
      termsOfServiceUrl={`${window.location.origin}/terms-of-user`}
      privacyPolicyUrl={`${window.location.origin}/privacy-terms`}
      agreementpreText="Your login constitutes acceptance of the "
      isShowLogin={isShowLogin}
      hideCloseIcon={true}
      onClose={() => {
        setIsShowLogin(false);
      }}
      needEmailLogin={true}
      emailPlace={t['com.affine.auth.sign.email.placeholder']()}
      codePlace={t['com.affine.auth.sign.email.code.placeholder']()}
      getCodeButtonText={t['com.affine.auth.sign.email.code.get']()}
      retryGetCodeButtonText={t['com.affine.auth.sign.email.code.retry']()}
      hasSendCodeMessageText={`${t['com.affine.auth.sign.email.code.resend']()}`}
      submitButtonText={t['com.affine.auth.sign.email.submit']()}
      getLoginCode={getLoginCode}
      handleReport={handleReport}
      loginErrorText={t['com.affine.auth.sign.email.code.invalid']()}
      emailErrorText={t['com.affine.auth.sign.email.invalid']()}
    />
  );
};
